module.exports = "ul li {\n  display: inline; }\n  ul li::after {\n    content: ', '; }\n  ul li:last-child::after {\n    content: ''; }\n"